module.exports = __webpack_public_path__ + "static/media/logo-green.f6883d5a.svg";